module.exports = "data:image/gif;base64,R0lGODlhHgAeALMAAMbZ6s3e7fj6/N/q89Tj7////+3z+Orx99vn8gAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAQUAP8ALAAAAAAeAB4AAARgEMhJq7046827/2BHhNxIasOpHWomtFdQwNYw05Rw4wBR7LjDjweQDXmGH7DlU/J0TppQuSQhqEdVE8vERklb7+nq/X6m5awImlZrAsk2tYSWmyuBAds+nxAIAwd7fFgRADs="


//////////////////
// WEBPACK FOOTER
// ./ramastangifs/bottomright.gif
// module id = 59
// module chunks = 4